var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1TabketSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.19 36H47.82A3.87 3.87 0 0044 39.81v18.37A3.87 3.87 0 0047.81 62h10.37A3.87 3.87 0 0062 58.19V39.82A3.87 3.87 0 0058.19 36zM58 58H48V40h10v18zm-35 0h18v4H22.81A3.87 3.87 0 0119 58.18V18.81A3.87 3.87 0 0122.82 15h25.37A3.87 3.87 0 0152 18.82V33h-4V19H23v39z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Tabket_smartphone.bdf53453.svg";
export { SvgH1TabketSmartphone as ReactComponent };